module.exports = __webpack_public_path__ + "static/media/relaxed-carefree.99bdbe54.png";